module.exports = __webpack_public_path__ + "assets/imgs/logos/ohm-query.30311bc2f2c5bb9883738f96c6442104.svg";